import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetDiscussions, EResetDiscussionsActionType } from './types';

export const resetDiscussions: () => TResetDiscussions = actionGenerator<EResetDiscussionsActionType.Reset>(
  EResetDiscussionsActionType.Reset,
);
